export const authTypes = {
  RESET:   'AUTH_RESET',
  REQUEST: 'AUTH_REQUEST',
  SENDING_POLICY: 'SENDING_POLICY',
};

export const registerTypes = {
  SUCCESS: 'REGISTER_SUCCESS',
  FAILED:  'REGISTER_FAILED'
};

export const resetPasswordTypes = {
  SUCCESS: 'RESET_PASSWORD_SUCCESS',
  FAILED:  'RESET_PASSWORD_FAILED'
};

export const changePasswordTypes = {
  SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  FAILED:  'CHANGE_PASSWORD_FAILED'
};